<template>
  <div>
    <component :is="isMobile ? 'div' : 'vue-lenis'" ref="lenisRef" v-bind="!isMobile ? { root: true, options: { lerp, autoRaf, duration } } : {}">
      <div class="main-home" ref="homeWrapper">
        <div class="header-container">
          <section id="home" class="main-home__slide slide carousel" ref="header">
            <video class="carousel-video" ref="heroVideo" autoplay muted playsinline preload="auto"
              src="https://ignisshowreel.s3.eu-west-1.amazonaws.com/landing_page_animation.mp4"
              type="video/mp4"></video>
            <div class="carousel-overlay"></div>
            <div class="carousel-text" :class="{ 'is-visible': showCarouselText }" ref="carouselText">
              <h1><span>Ideas that spark action.<br /></span> Helping you own the moments that matter via Experiential, Shopper or Social.</h1>
            </div>
            <div class="carousel-blackout"></div>
          </section>
        </div>
        <DisciplinePanel name="experiential" id="disciplines" linked />
        <DisciplinePanel name="shopper" linked />
        <DisciplinePanel name="social" linked />
        <DisciplinePanel name="comms" linked />

        <section class="main-home__slide slide-6" ref="clients">
          <div class="slide-6__container">
            <div class="slide-6__container__title">
              <h1><span class="heading-script">Company</span>You're in good company</h1>
            </div>
            <div class="slide-6__container__logos">
              <div class="slide-6__container__logos__row-1">
                <router-link to="/our-work/pepsi-max" class="logo-box pepsi">
                  <img :src="require('@/assets/images/client-logos/pepsi.png')" alt="Pepsi"
                    class="bulls-text-overlay" loading="lazy" />
                </router-link>
                <router-link to="/our-work/marriott" class="logo-box">
                  <img :src="require('@/assets/images/client-logos/marriot.png')" alt="Marriot"
                    class="bulls-text-overlay" loading="lazy" />
                </router-link>
                <div class="logo-box">
                  <img :src="require('@/assets/images/client-logos/nestle.png')" alt="Nestle"
                    class="bulls-text-overlay" loading="lazy" />
                </div>
                <div class="logo-box">
                  <img :src="require('@/assets/images/client-logos/tango.png')" alt="Tango"
                    class="bulls-text-overlay" loading="lazy" />
                </div>
              </div>

              <div class="slide-6__container__logos__row-2">
                <div class="logo-box peroni">
                  <img :src="require('@/assets/images/client-logos/hilton.png')" alt="Hilton"
                    class="bulls-text-overlay" loading="lazy" />
                </div>
                <div class="logo-box peroni">
                  <img :src="require('@/assets/images/client-logos/nordic.png')" alt="Nordic"
                    class="bulls-text-overlay" loading="lazy" />
                </div>
                <div class="logo-box cleanco">
                  <img :src="require('@/assets/images/client-logos/ploom.png')" alt="Ploom"
                    class="bulls-text-overlay" loading="lazy" />
                </div>
                <router-link to="/our-work/jti-human-rights" class="logo-box hilton">
                  <img :src="require('@/assets/images/client-logos/jti.png')" alt="JTI" class="bulls-text-overlay" loading="lazy" />
                </router-link>
              </div>

              <div class="slide-6__container__logos__row-3">
                <div class="logo-box">
                  <img :src="require('@/assets/images/client-logos/biotiful.png')" alt="Biotiful"
                    class="bulls-text-overlay" loading="lazy" />
                </div>
                <div class="logo-box">
                  <img :src="require('@/assets/images/client-logos/fruit_shoot.png')" alt="Fruit Shoot"
                    class="bulls-text-overlay" loading="lazy" />
                </div>
                <div class="logo-box sevenUp">
                  <img :src="require('@/assets/images/client-logos/7up.png')" alt="7up" class="bulls-text-overlay" loading="lazy" />
                </div>
                <router-link to="/our-work/lipton-ice-tea" class="logo-box">
                  <img :src="require('@/assets/images/client-logos/lipton.png')" alt="Lipton"
                    class="bulls-text-overlay" loading="lazy" />
                </router-link>
              </div>
            </div>

            <div class="slide-6__container__logos_mobile">
              <div class="slide-6__container__logos__row-1">
                <router-link to="/our-work/pepsi-max" class="logo-box">
                  <img :src="require('@/assets/images/client-logos/pepsi.png')" alt="Pepsi"
                    class="bulls-text-overlay" loading="lazy" />
                </router-link>
                <router-link to="/our-work/marriott" class="logo-box">
                  <img :src="require('@/assets/images/client-logos/marriot.png')" alt="Marriot"
                    class="bulls-text-overlay" loading="lazy" />
                </router-link>
                <div class="logo-box">
                  <img :src="require('@/assets/images/client-logos/nestle.png')" alt="Nestle"
                    class="bulls-text-overlay" loading="lazy" />
                </div>
              </div>

              <div class="slide-6__container__logos__row-2">
                <div class="logo-box">
                  <img :src="require('@/assets/images/client-logos/tango.png')" alt="Tango"
                    class="bulls-text-overlay" loading="lazy" />
                </div>
                <div class="logo-box">
                  <img :src="require('@/assets/images/client-logos/hilton.png')" alt="Hilton"
                    class="bulls-text-overlay" loading="lazy" />
                </div>
                <div class="logo-box">
                  <img :src="require('@/assets/images/client-logos/nordic.png')" alt="Nordic"
                    class="bulls-text-overlay" loading="lazy" />
                </div>
              </div>

              <div class="slide-6__container__logos__row-3">
                <div class="logo-box cleanco">
                  <img :src="require('@/assets/images/client-logos/ploom.png')" alt="Plooom"
                    class="bulls-text-overlay" loading="lazy" />
                </div>
                <router-link to="/our-work/jti-human-rights" class="logo-box hilton">
                  <img :src="require('@/assets/images/client-logos/jti.png')" alt="JTI" class="bulls-text-overlay" loading="lazy" />
                </router-link>
                <div class="logo-box london-pride">
                  <img :src="require('@/assets/images/client-logos/biotiful.png')" alt="Biotiful"
                    class="bulls-text-overlay" loading="lazy" />
                </div>
              </div>

              <div class="slide-6__container__logos__row-4">
                <div class="logo-box">
                  <img :src="require('@/assets/images/client-logos/fruit_shoot.png')" alt="Fruit Shoot"
                    class="bulls-text-overlay" loading="lazy" />
                </div>
                <div class="logo-box">
                  <img :src="require('@/assets/images/client-logos/7up.png')" alt="7up" class="bulls-text-overlay" loading="lazy" />
                </div>
                <router-link to="/our-work/lipton-ice-tea" class="logo-box">
                  <img :src="require('@/assets/images/client-logos/lipton.png')" alt="Lipton"
                    class="bulls-text-overlay" loading="lazy" />
                </router-link>
              </div>
            </div>
          </div>
        </section>

        <div class="showreel-container" ref="videoContainer">
          <div class="showreel-video-container">
            <PlayIcon v-if="!showreelOpen" class="play-button" @click="openShowreel"></PlayIcon>
            <video id="video1" ref="showreelVideo" muted loop
              preload="auto" playsinline @click="openShowreel"
              :poster="require('@/assets/images/poster-sr.png')"
              :src="SHOWREEL_SRC"
              type="video/mp4">
            </video>
          </div>

          <!-- Expanded showreel: grows from the preview, height first then width -->
          <Teleport to="body">
            <div v-if="showreelOpen" class="showreel-overlay">
              <div class="showreel-overlay__backdrop" ref="overlayBackdrop" @click="closeShowreel"></div>
              <div class="showreel-overlay__frame" ref="overlayFrame">
                <video ref="overlayVideo" v-track-video="'homepage-showreel'" playsinline preload="auto"
                  :src="SHOWREEL_SRC" @ended="closeShowreel" @click="toggleOverlayPlayback"></video>
              </div>
              <button class="showreel-overlay__close" ref="overlayClose" aria-label="Close video"
                @click="closeShowreel">
                <!-- Same red disc as PlayIcon, with a thin white cross centred on it -->
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 569.3 569.3" aria-hidden="true">
                  <circle cx="284.65" cy="284.65" r="284.65" fill="#E20034" />
                  <path d="M204.65 204.65 L364.65 364.65 M364.65 204.65 L204.65 364.65" stroke="#fff"
                    stroke-width="16" stroke-linecap="round" fill="none" />
                </svg>
              </button>
            </div>
          </Teleport>
          <div class="showreel-container__accolades">
            <div>
              <img :src="require('@/assets/images/eot_logo_white.png')" alt="EOA - Proudly employee owned" />
            </div>
          </div>

        </div>
        <div class="footer" id="contact">
          <div class="footer-wrapper" ref="footer">
            <div class="footer__details">
              <div class="footer__details-section">
                <div class="footer__details-section-social">
                  <IgnisLogo></IgnisLogo>

                  <ul>
                    <li><a href="https://www.linkedin.com/company/ignis-ltd/">
                        <img :src="require('@/assets/images/linked_in.svg')" />
                      </a>
                    </li>
                    <li><a href="https://www.tiktok.com/@ignisagency">
                        <img :src="require('@/assets/images/tiktok.svg')" />

                      </a>
                    </li>
                    <li><a href="https://www.instagram.com/ignisagency">
                        <img :src="require('@/assets/images/instagram.svg')" />
                      </a>
                    </li>
                  </ul>
                  <img :src="require('@/assets/images/eot_logo_white.png')" alt="EOA - Proudly employee owned" />
                </div>

                <div class="footer__details-section-links">
                  <ul>
                    <li><router-link to="/our-work">Our Work</router-link></li>
                    <li><router-link to="/#home">About Us</router-link></li>
                    <li><router-link to="/#disciplines">Disciplines</router-link></li>
                    <li><router-link to="/our-people">Our People</router-link></li>
                  </ul>
                </div>

                <div class="footer__details-section-coffee">
                  <h3>Coffee?</h3>
                  <div class="footer-copy">
                    <span class="break-after">St. John's Hall, </span>
                    <span class="break-after">374 North End Road </span>
                    <span class="break-after">Fulham, London, SW6 1LY</span>
                  </div>
                </div>

                <div class="footer__details-section-chat">
                  <h3>Chat?</h3>
                  <div class="footer-copy">
                    <a href="tel:+44 (0) 207 385 6677" data-track-type="enquiry" data-track-location="footer">+44 (0) 207 385 6677</a>
                    <p>Ask to speak to Jackie</p>
                    <a href="mailto:jackie@ignis.co.uk" data-track-type="enquiry" data-track-location="footer">jackie@ignis.co.uk</a>
                  </div>

                  <h3>Join?</h3>
                  <div class="footer-copy">
                    <p>
                      Join our award winning team.
                      Send your portfolio/CV to:
                    </p>
                    <a href="mailto:jackie@ignis.co.uk" data-track-type="careers" data-track-location="footer">jackie@ignis.co.uk</a>

                  </div>
                </div>

              </div>
              <div class="footer__copyright">
                <div class="footer__copyright-content">
                  <div class="footer__copyright-links">
                    <a href="/privacy-policy">Privacy Policy</a>
                    <a href="/cookie-policy">Cookies</a>
                  </div>
                  <div class="footer__copyright-text">
                    © Ignis Ltd 2026
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </component>
  </div>
</template>

<script setup>
import { useLenis } from 'lenis/vue'
import { gsap } from 'gsap';
import PlayIcon from '@/components/svg/PlayIcon';
import ScrollTrigger from 'gsap/ScrollTrigger';
import DrawSVGPlugin from "@/plugins/gsap/DrawSVGPlugin";
import ScrambleTextPlugin from "@/plugins/gsap/ScrambleTextPlugin";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import IgnisLogo from "@/components/svg/IgnisLogo";
import DisciplinePanel from "@/components/DisciplinePanel";
import { useDisciplineAnimations } from "@/composables/useDisciplineAnimations";
import { useLazyVideos } from "@/composables/useLazyVideos";
import { useGlobalStore } from '@/stores/global';

import { ref, onMounted, onUnmounted, nextTick } from 'vue';

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(DrawSVGPlugin);
gsap.registerPlugin(ScrambleTextPlugin);
gsap.registerPlugin(ScrollToPlugin);
const isMobile = window.matchMedia('(max-width: 1024px)').matches;
const lerp = ref(0.1);
const autoRaf = ref(false);
const duration = ref(1.2);
const globalStore = useGlobalStore();
const heroVideo = ref(null);
const showCarouselText = ref(false);
const header = ref(null);
const footer = ref(false);
const showreelVideo = ref(null);
const SHOWREEL_SRC = 'https://ignisshowreel.s3.eu-west-1.amazonaws.com/landing_page_short_v2.mp4';
const showreelOpen = ref(false);
const overlayBackdrop = ref(null);
const overlayFrame = ref(null);
const overlayVideo = ref(null);
const overlayClose = ref(null);
let showreelTimeline = null;
let showreelClosing = false;

// Expanded size: the largest 16:9 box that fits the window, leaving room for the
// 18px green corner borders and a strip at the top for the close button
const getShowreelTarget = () => {
  const isSmall = window.innerWidth <= 768;
  const gutter = isSmall ? 30 : 50;
  const topSpace = isSmall ? 90 : 116;
  const availWidth = window.innerWidth - gutter * 2;
  const availHeight = window.innerHeight - topSpace - gutter;
  const width = Math.min(availWidth, availHeight * 16 / 9);
  const height = width * 9 / 16;
  return {
    left: (window.innerWidth - width) / 2,
    width,
    top: topSpace + (availHeight - height) / 2,
    height,
  };
};

// Close button sits just above the frame, its right edge in line with the green border
const placeShowreelClose = (target) => {
  const button = overlayClose.value;
  if (!button) return;
  const size = button.offsetWidth;
  const border = 18;
  const gap = window.innerWidth <= 768 ? 12 : 14;
  gsap.set(button, {
    left: target.left + target.width + border - size,
    top: target.top - border - gap - size,
  });
};

const lockScroll = (locked) => {
  const lenisInstance = lenisRef.value?.lenis;
  if (lenisInstance) locked ? lenisInstance.stop() : lenisInstance.start();
  document.documentElement.style.overflow = locked ? 'hidden' : '';
};

const openShowreel = async () => {
  const preview = showreelVideo.value;
  if (!preview || showreelOpen.value) return;

  const rect = preview.getBoundingClientRect();
  showreelOpen.value = true;
  lockScroll(true);
  await nextTick();

  const frame = overlayFrame.value;
  const video = overlayVideo.value;
  const target = getShowreelTarget();
  const ease = 'power3.inOut';

  gsap.set(frame, { top: rect.top, left: rect.left, width: rect.width, height: rect.height });
  gsap.set([overlayBackdrop.value, overlayClose.value], { autoAlpha: 0 });
  placeShowreelClose(target);

  video.muted = false;
  video.play().catch(() => {
    // Browser blocked sound: play muted and let a tap unmute
    video.muted = true;
    video.play().catch(() => {});
  });

  showreelTimeline = gsap.timeline()
    .to(overlayBackdrop.value, { autoAlpha: 1, duration: 0.4 }, 0)
    .to(frame, { top: target.top, height: target.height, duration: 0.6, ease }, 0)
    .to(frame, { left: target.left, width: target.width, duration: 0.6, ease })
    .to(overlayClose.value, { autoAlpha: 1, duration: 0.25 });
};

const closeShowreel = () => {
  if (!showreelOpen.value || showreelClosing) return;
  showreelClosing = true;
  showreelTimeline?.kill();

  const preview = showreelVideo.value;
  const video = overlayVideo.value;
  video.pause();
  // Leave the preview on the frame the viewer stopped at, so the hand-back is seamless
  if (preview && video.currentTime && !video.ended) preview.currentTime = video.currentTime;

  const rect = preview.getBoundingClientRect();
  const ease = 'power3.inOut';

  showreelTimeline = gsap.timeline({
    onComplete: () => {
      showreelOpen.value = false;
      showreelClosing = false;
      lockScroll(false);
    },
  })
    .to(overlayClose.value, { autoAlpha: 0, duration: 0.15 })
    .to(overlayFrame.value, { left: rect.left, width: rect.width, duration: 0.5, ease })
    .to(overlayFrame.value, { top: rect.top, height: rect.height, duration: 0.5, ease })
    .to(overlayBackdrop.value, { autoAlpha: 0, duration: 0.4 }, '-=0.4');
};

const toggleOverlayPlayback = () => {
  const video = overlayVideo.value;
  if (!video) return;
  if (video.muted) {
    video.muted = false;
    return;
  }
  video.paused ? video.play() : video.pause();
};

const onShowreelKeydown = (e) => {
  if (e.key === 'Escape') closeShowreel();
};

const onShowreelResize = () => {
  if (!showreelOpen.value || showreelClosing) return;
  showreelTimeline?.progress(1);
  const target = getShowreelTarget();
  gsap.set(overlayFrame.value, target);
  placeShowreelClose(target);
};
const clients = ref(false);

const homeWrapper = ref(null);
const videoContainer = ref(null);
const carouselText = ref(null);

// eslint-disable-next-line no-unused-vars
const lenis = isMobile ? ref(null) : useLenis(
  () => {},
  0,
  'root'
)
const lenisRef = ref()
let lenisTicker = null;
let homeMedia = null;

// Discipline animations composable
const { initDisciplineAnimations } = useDisciplineAnimations(gsap);
const { setupLazyVideos } = useLazyVideos();

onUnmounted(() => {
  window.removeEventListener('keydown', onShowreelKeydown);
  window.removeEventListener('resize', onShowreelResize);
  showreelTimeline?.kill();
  if (showreelOpen.value) lockScroll(false);
  // Stop driving Lenis from the GSAP ticker — otherwise the destroyed instance keeps
  // easing towards its old target and drags the next page back to the homepage scroll position.
  if (lenisTicker) gsap.ticker.remove(lenisTicker);
  homeMedia?.revert();
  ScrollTrigger.killAll();
});


// Mounted lifecycle hook
onMounted(() => {
  window.addEventListener('keydown', onShowreelKeydown);
  window.addEventListener('resize', onShowreelResize);

  // Signal page is ready immediately (no longer gated on video canplay)
  globalStore.heroVideoReady = true;

  // Safari-compatible video play: .load() forces Safari to start buffering,
  // then play once the browser signals it has enough data (canplay event).
  nextTick(() => {
    const video = heroVideo.value;
    if (video) {
      video.load();
      video.addEventListener('canplay', () => { video.play().catch(() => {}); }, { once: true });
      video.play().catch(() => {});
    }
  });

  // Show carousel text after a short delay
  setTimeout(() => {
    showCarouselText.value = true;
  }, 3800);

  // Set up lazy video loading
  setupLazyVideos();

  nextTick(() => {
    // Wrap in rAF so Safari has completed at least one full layout/paint cycle
    // before GSAP reads element positions. Vue's nextTick flushes the vDOM but
    // does NOT guarantee the browser has finished layout — Safari is strict about
    // this, causing getBoundingClientRect() to return stale values and the
    // ScrollTrigger pin to land off-screen on cold start.
    requestAnimationFrame(() => {
      // Connect Lenis scroll position to GSAP ScrollTrigger (desktop only)
      if (!isMobile) {
        const lenisInstance = lenisRef.value?.lenis;
        if (lenisInstance) {
          lenisInstance.on('scroll', ScrollTrigger.update);
          lenisTicker = (time) => lenisInstance.raf(time * 1000);
          gsap.ticker.add(lenisTicker);
          gsap.ticker.lagSmoothing(0);
        }
      }

      // Force initial layout for smooth transitions
      const disciplineSlides = document.querySelectorAll('.disciplines-section .main-home__slide');
      if (disciplineSlides.length > 0) {
        disciplineSlides.forEach(slide => {
          slide.offsetHeight; // Force reflow
        });
      }

      // Init discipline panel scroll animations
      initDisciplineAnimations();

      // Slow scroll effect for the first section.
      // Must run AFTER Lenis is connected so ScrollTrigger pin measures correct scroll metrics.
      homeMedia = gsap.matchMedia();
      homeMedia.add("(min-width: 1025px)", () => {

        gsap.to(header.value, {
          yPercent: -40, // Moves up slowly
          ease: 'none',
          scrollTrigger: {
            trigger: header.value,
            start: 'top top',
            end: '+=60%',
            scrub: 0.5,
            pin: true
          },
        });

        // Fade header to black as disciplines scrolls up into it
        gsap.to('.carousel-blackout', {
          opacity: 1,
          ease: 'none',
          scrollTrigger: {
            trigger: '.panel-brands-container',
            start: 'top bottom',
            end: 'top 45%',
            scrub: true,
          },
        });

        gsap.set(footer.value, { yPercent: -100 });

        gsap.to(footer.value, {
          yPercent: 0,
          ease: 'none',
          scrollTrigger: {
            trigger: clients.value,
            start: 'bottom bottom',
            end: 'bottom top',
            scrub: true,
          },
        });
      });

      // Recalculate ScrollTrigger positions once web fonts are fully loaded.
      // On cold start, Google Fonts swap in after GSAP has already measured elements,
      // causing the pinned header to land at a wrong position.
      document.fonts.ready.then(() => ScrollTrigger.refresh());
    });
  });

  gsap.set(".attention-title", { autoAlpha: 0 });
  let tl = gsap.timeline({
    defaults: {
      duration: 0.2, ease: 'power2.inOut',
    }
  });
  tl.to('.attention-title', { autoAlpha: 1 })
    .fromTo('.attention-title #Mask-A', {
      drawSVG: '0% 0%'
    }, { drawSVG: true })
    .fromTo('.attention-title #Mask-T', {
      drawSVG: '0% 0%'
    }, { drawSVG: true })
    .fromTo('.attention-title #Mask-T2', {
      drawSVG: '0% 0%'
    }, { drawSVG: true })
    .fromTo('.attention-title #Mask-E', {
      drawSVG: '0% 0%'
    }, { drawSVG: true })
    .fromTo('.attention-title #Mask-N', {
      drawSVG: '100% 100%'
    }, { drawSVG: true })
    .fromTo('.attention-title #Mask-T3', {
      drawSVG: '0% 0%'
    }, { drawSVG: true })
    .fromTo('.attention-title #Mask-I', {
      drawSVG: '0% 0%'
    }, { drawSVG: true })
    .fromTo('.attention-title #Mask-IDot', {
      drawSVG: '0% 0%'
    }, { drawSVG: true })
    .fromTo('.attention-title #Mask-O', {
      drawSVG: '0% 0%'
    }, { drawSVG: true })
    .fromTo('.attention-title #Mask-N2', {
      drawSVG: '100% 100%'
    }, { drawSVG: true });
});

</script>


<style lang="scss">
@function best-text-color($bg-color, $light-color, $dark-color) {
  $lightness: lightness($bg-color);
  @return if($lightness > 50%, $dark-color, $light-color);
}

.inline-icon {
  display: inline-block;
  vertical-align: middle;
  margin: 0 8px;
}

.slide-1__video-wrapper {
  display: none;
  visibility: hidden;
}

.v-main__wrap {
  position: unset;
}

// The discipline name as a real heading (h1/h2) around the title graphic,
// without the heading's own box or type styles changing the panel layout.
.main-home .discipline-heading {
  display: block;
  margin: 0 !important;
  padding: 0 !important;
  font: inherit !important;

  a {
    display: block;
  }
}

// Let clicks through the script overlay to the heading link beneath it
.discipline-title--passthrough {
  pointer-events: none;
}

.discipline-link {
  display: contents; // keep the existing flex/grid sizing of the thumbs

  video,
  img {
    cursor: pointer;
    transition: transform 0.4s ease, filter 0.4s ease;
  }

  &:hover,
  &:focus-visible {
    video,
    .parallax-container img {
      transform: scale(1.04);
      filter: brightness(1.08);
    }
  }
}

.play-cursor {
  cursor: url('../assets/images/play.svg'), pointer;
  transition: all 0.3 ease-in-out;
}

.pause-cursor {
  cursor: url('../assets/images/pause.svg'), pointer;
  transition: all 0.3 ease-in-out;
}

.attention-title {
  fill: $ignis-red;
  opacity: 1;
}

.mask {
  fill: none;
  stroke: #fff;
  stroke-miterlimit: 10;
}

.main-home {
  position: relative;
  z-index: 4;

  .header-container {
    // position: fixed;
    height: 100vh;
    width: 100%;
    top: 0;
    z-index: 1;
    pointer-events: none;
    /* Allows sections to scroll over it */
  }

  margin: 0;
  background-color: #000;

  .fade-in {
    opacity: 0;
    transition: opacity 0.8s ease-in;
  }

  .fade-in.show {
    opacity: 1;
  }

  &__slide {
    width: 100%;
    display: flex;
    height: 100vh;
    position: relative;

    @media screen and (max-width: 768px) {
      min-height: unset !important;
      // height: unset;
    }

    &-static-header-desktop {
      position: absolute;
      top: calc((100vh - 640px) / 4);
      left: 50vw;
      transform: translateX(-50%);
      width: 300px;
      z-index: 100;

      @media screen and (max-height: 830px) {
        //top: 20px;
        position: fixed;
        top: 62px;
      }

      h2 {
        font-family: $font-stack-bison;
        font-size: 4.5em;
        line-height: 1;
        text-align: center;
        color: var(--color-black);
        width: 100%;

        @media screen and (max-width: 1024px) {
          display: none;
          font-size: 2.5em;
        }
      }
    }
  }

  // Panel Image Styles
  .panel-image {
    position: absolute;
    width: 100%;
    height: 100%;
    background: #000000;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: start;
    opacity: 0;
    visibility: hidden;
    pointer-events: none;
    transition: opacity 0.3s ease, visibility 0.3s ease;
    z-index: 5;

    h3 {
      position: absolute;
      writing-mode: sideways-lr;
      text-orientation: mixed;
      text-transform: uppercase;
      font-size: 1.1rem;
      color: #FFF;
      margin: 0;
      bottom: 50px;
      font-weight: 200 !important;
      font-family: "Overpass", sans-serif !important;
    }

    img {
      width: 100px;
      object-fit: contain;
      display: none;
    }

  }

  // Vertical Accordion Styles
  .disciplines-container {
    position: relative;
    min-height: 582px;
    height: 100vh;
    width: 100%;
    background-color: transparent;
    z-index: 1;
    overflow: hidden;

    h2 {
      font-family: "Overpass", sans-serif !important;
      margin: 0;
      padding: 0 0 10px;
      color: #E20034;
      text-align: center;
      font-size: 2em;
      text-transform: uppercase;
    }
  }

  // Marquee layer base styles
  .marquee-layer {
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
    width: 200vw;
    pointer-events: none;
    z-index: 0;
    opacity: 0;
    white-space: nowrap;
    display: flex;
    align-items: center;

    img {
      width: 200vw;
      height: auto;
      display: block;
      opacity: 0.12;
    }

    @media screen and (max-width: 1024px) {
      display: none;
    }
  }

  .marquee-layer--png {
    z-index: 0;
  }

  .marquee-layer--html {
    z-index: 4;
  }

  .marquee-text {
    font-family: $font-stack-bison;
    font-size: 16vw;
    text-transform: uppercase;
    color: rgba(255, 255, 255, 0.06);
    letter-spacing: 0.05em;
    padding: 0 0.3em;
    line-height: 1;
    white-space: nowrap;
  }

  // Scrolling depth background graphic
  .panel-depth-bg {
    position: absolute;
    inset: 0;
    z-index: 0;
    pointer-events: none;
    opacity: 0;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 120%;
      height: auto;
      filter: brightness(0) invert(0) opacity(0.15);
      transform: scale(1.3);
    }

    @media screen and (max-width: 1024px) {
      display: none;
    }
  }

  .disciplines-section {
    display: flex;
    flex-direction: row;
    height: 100vh;
    width: 100%;
    overflow: hidden;
    background: transparent;

    .main-home__slide {
      transition: flex 0.8s cubic-bezier(0.15, 1, 0.5, 1);
      overflow: hidden;
      position: relative;
      will-change: flex;
      transform: translateZ(0); // Force GPU acceleration
    }

    .discipline-copy {
      color: #FFF;
      font-size: 1.4em;
      font-weight: 300;
      margin: 2.5em 0 0;
      padding: 0 30px;
      text-align: center;
      line-height: 1.2;
      max-width: 80%;

      @media screen and (max-width: 1024px) {
        max-width: 100%;
        font-size: 1.2em;
      }
    }

    // Mobile responsiveness - stack vertically, expand bottom to top
    @media screen and (max-width: 1024px) {
      flex-direction: column;
      height: 100vh;

      .main-home__slide {
        width: 100%;
        height: 100vh;
        align-items: center;
        transition: flex 0.5s cubic-bezier(0.15, 1, 0.5, 1);

        &.is-expanded {
          flex: 1 1 0%;
        }

        &.is-collapsed {
          flex: 0 0 60px;
        }
      }

      .panel-image {
        h3 {
          writing-mode: horizontal-tb;
          text-orientation: mixed;
          font-size: 0.9rem;
          bottom: auto;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }

        img {
          height: 60px;
          width: auto;
        }
      }
    }
  }

  #home {
    height: 100dvh !important;
    background-position: 50% 50%;
    min-height: unset;
  }

  .slide-1 {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100dvh;
    perspective: 1000px;
    transform-style: preserve-3d;
    color: #fff;


    #video2 {
      display: none;
    }

    &__video-wrapper {
      position: relative;
      width: 100%;
      height: 100dvh;
      // min-height: 834px;

      @media screen and (max-width: 1024px) {
        // min-height: unset;
      }

      &__container {
        &__video {
          object-fit: cover;
          width: 100%;
          height: 100%;
          padding: 0;
          position: absolute;
        }

        &__controls {
          position: absolute;
          bottom: 60px;
          right: 10px;
          display: flex;
          gap: 5px;
          z-index: 10;
        }

        &__controls-play {
          position: absolute;
          left: calc(50% - 50px);
          top: 50%;
          transform: translate(-50% -50%);
          z-index: 10;
          height: fit-content;
        }
      }
    }

    .play-pause-btn,
    .mute-unmute-btn,
    .fullscreen-btn {
      width: 30px;
      height: 30px;
      background-color: rgba(0, 0, 0, 0.7);
      color: #fff;
      border: none;
      cursor: pointer;
      font-size: 22px;
      border-radius: 5px;
    }

    .play-btn {
      background-color: unset;
      color: #E20034;
      font-size: 4em;
      height: fit-content;
      // mix-blend-mode: multiply;

      svg {
        fill-opacity: 1;
      }

    }

    .play-btn:hover,
    .play-pause-btn:hover,
    .mute-unmute-btn:hover,
    .fullscreen-btn:hover {
      cursor: none;
      background-color: rgba(0, 0, 0, 1);
    }

  }

  .slide {
    background-color: #000000;
    text-align: center;
    display: block;
    color: #ffffff;

    &.black-bg {
      background-color: #000;
    }

    &.carousel {
      position: relative;
      overflow: hidden;
      display: flex;
      align-items: end;
      justify-content: center;

      .carousel-video {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
        z-index: 0;

        @media screen and (max-width: 768px) {
          object-fit: contain;
          transform: scale(1.8);
        }
      }

      .carousel-overlay {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: linear-gradient(to top, rgba(0, 0, 0, 0.8) 0%, rgba(0, 0, 0, 0) 60%);
        z-index: 1;
        pointer-events: none;
      }

      .carousel-blackout {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: #000;
        opacity: 0;
        z-index: 3;
        pointer-events: none;
      }

      .carousel-text {
        padding: 0 0 80px;
        position: relative;
        z-index: 1;
        opacity: 0;
        transition: opacity 1.2s ease;
        width: 640px;

        &.is-visible {
          opacity: 1;
        }

        h1 {
          font-family: "Overpass", sans-serif !important;
          text-transform: uppercase;
          font-weight: 200;
          font-size: 1.8em;
          line-height: 1.1;
        }

        span {
          font-weight: 600;
        }

        p {
          padding: 20px 0 0;
          line-height: 1.2;
        }

        @media screen and (max-width: 1024px) {

          h1 {
            font-size: 1.2em;
            padding: 0 30px;
          }
        }
      }

      @media screen and (max-width: 1024px) {
        // background-position: 71%;

        .carousel-text {
          padding: 0 0 60px;
        }

        align-items: end;

      }
    }

    &__title {
      width: 100%;
      padding: 0;
      margin-bottom: 60px;
      position: relative;
      z-index: 2;

      @media screen and (max-width: 768px) {
        margin-bottom: 30px;
      }

      h2 {
        font-weight: 300;
        color: #ffffff;
        font-size: 5em;
        line-height: 0.775em;
        text-align: center;

        @media screen and (max-width: 768px) {
          font-size: 3.5em
        }

      }
    }

    .uncomfortably_script {
      position: absolute;
      top: -130px;
      left: 30px;
      z-index: -1;

      img {
        width: 580px;

      }

      @media screen and (max-width: 768px) {
        display: none;
      }
    }

    .experience_script {
      position: absolute;
      top: -150px;
      left: 60px;
      z-index: -1;

      img {
        width: 540px;
      }

      @media screen and (max-width: 768px) {
        display: none;
      }
    }

    p {
      font-size: 1.15em;
      color: #ffffff;
      line-height: 1.6;
      font-weight: 300;
      text-align: center;
      max-width: 660px;
    }

    .fancy-link {
      font-family: $font-stack-bison;
      margin: 40px 0 0 0;
      font-size: 2em;
      color: var(--color-red);
      transition: all 0.3s ease-in-out;

      &.work {
        color: #ffffff;
      }

      img {
        width: 40px;
      }

      &:hover {
        transition: all 0.3s ease-in-out;
        transform: scale(1.05);

      }
    }

    &__container {
      display: flex;
      justify-content: center;
      flex-direction: column;
      width: 100%;
      height: 100vh;
      // min-height: 1024px;

      &__work {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        max-width: 960px;
        margin: 0 auto 0;
        height: calc(100vh - 212px);
        position: relative;

        @media screen and (max-width: 768px) {
          width: 100%;
          padding: 30px 0 0;
          margin: 40px auto 0;
        }

        .category_video {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);

          video {
            filter: brightness(0.6);
            width: 456px;
            opacity: 0.95;
          }

          @media screen and (max-width: 1024px) {
            display: none;
          }
        }

        @media screen and (max-width: 1024px) {
          .category_video_mobile {
            display: block;
            position: absolute;
            top: 0;
            left: 50%;
            transform: translate(-50%, 0);

            video {
              filter: brightness(0.6);
              opacity: 1;
            }
          }
        }


        @media screen and (min-width: 1025px) {
          .category_video_mobile {
            display: none;
          }
        }

        &-text {
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: row;
          color: #ffffff;
          font-size: 3em;
          line-height: 1;
          margin-bottom: 0.8em;
          padding: 0 0 0 0.4em;
          letter-spacing: 0.4em;
          width: 100%;
          // min-height: 100px;
          direction: rtl;

          &.slide-in {
            opacity: 0;
          }

          &:last-child {
            margin-bottom: 0;
          }


          :first-letter {
            letter-spacing: 0;
            display: unset !important;
          }
        }

        .heading-script {
          color: #000;
        }
      }

      &__deliver {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        max-width: 960px;
        margin: 0 auto;
        position: relative;

        .category_video {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);

          video {
            filter: brightness(0.6);
            width: 456px;
            opacity: 0.95;
          }

          @media screen and (max-width: 1024px) {
            display: none;
          }
        }

        .slide__title {
          margin-bottom: 30px;
        }

        @media screen and (max-width: 1024px) {
          width: 100%;
          padding: 30px 0 0 0;

          .category_video_mobile {
            display: block;
            position: absolute;
            top: 0;
            left: 50%;
            transform: translate(-50%, 0);

            video {
              filter: brightness(0.6);
              opacity: 1;
            }
          }

          .fancy-link {
            margin: 0;
          }
        }


        @media screen and (min-width: 1025px) {
          .category_video_mobile {
            display: none;
          }
        }

        &-text {
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: row;
          color: #ffffff;
          font-size: 3em;
          line-height: 1;
          margin-bottom: 0.8em;
          padding: 0 0 0 0.4em;
          letter-spacing: 0.4em;
          width: 100%;
          // min-height: 100px;
          direction: rtl;

          &.slide-in {
            opacity: 0;
          }

          &:last-child {
            margin-bottom: 0;
          }


          :first-letter {
            letter-spacing: 0;
            display: unset !important;
          }
        }

        .heading-script {
          color: $ignis-red;
        }
      }

      @media screen and (max-width: 1024px) {
        height: 100%;
        min-height: unset;
        padding: 30px;

      }

      &.challenger-thinking {
        height: 100vh;
        // min-height: 1024px;

        @media screen and (max-width: 768px) {
          height: calc(100vh - 112px);
        }
      }

    }

    .panel-deliver {
      &-thumbs {
        display: flex;
        justify-content: center;
        gap: 20px;
        max-width: 960px;
        width: 100%;
        margin: 50px auto 0;
        z-index: 1;

        @media screen and (max-width: 768px) {
          padding: 30px 30px;
          margin: 0;
          width: 100%;
          display: grid;
          grid-template-columns: repeat(2, 1fr);
        }

        div {
          width: calc(100% / 4);
          max-width: calc(100% / 4);
          height: 100%;
          display: flex;
          align-items: end;
          justify-content: center;
          position: relative;

          @media screen and (max-width: 768px) {
            width: 100%;
            max-width: 100%;
            height: -webkit-fit-content;
            padding-bottom: 5px !important;
          }

          img {
            height: 30%;

            @media screen and (max-width: 768px) {
              height: 50px;
            }
          }
        }

        .deliver-thumb-1 {
          background-image: linear-gradient(to top, rgba(0, 0, 0, 0.8) 0%, rgba(0, 0, 0, 0) 40%),
            url('@/assets/images/our-work/asahi_thumb.png');
          background-size: cover;
          background-repeat: no-repeat;
          aspect-ratio: 1/1;

          &::before,
          &::after {
            content: "";
            position: absolute;
            background-color: #00FF00;
          }

          &::before {
            width: 12px;
            height: 60%;
            left: -12px;
            top: 0;
          }

          &::after {
            width: calc(60% + 12px);
            height: 12px;
            left: -12px;
            top: -12px;
          }

          .work-link {
            height: 100%;
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: end;
            padding-bottom: 10px;
          }
        }

        .deliver-thumb-2 {
          background-image: linear-gradient(to top, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0) 40%),
            url('@/assets/images/our-work/britvic_mixers.png');
          background-size: cover;
          background-repeat: no-repeat;
          aspect-ratio: 1/1;

          .work-link {
            height: 100%;
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: end;
            padding-bottom: 10px;
          }
        }

        .deliver-thumb-3 {
          background-image: linear-gradient(to top, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0) 40%), url('@/assets/images/our-work/lipton_ice_tea_thumb.png');
          background-size: cover;
          background-repeat: no-repeat;
          padding-bottom: 10px;
          aspect-ratio: 1/1;

          .work-link {
            height: 100%;
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: end;
            padding-bottom: 10px;
          }
        }

        .deliver-thumb-4 {
          background-image: linear-gradient(to top, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0) 40%), url('@/assets/images/our-work/campari_our_work_thumb.png');
          background-size: cover;
          background-repeat: no-repeat;
          padding-bottom: 10px;
          aspect-ratio: 1/1;

          &::before,
          &::after {
            content: "";
            position: absolute;
            background-color: #00FF00;
          }

          &::before {
            width: 12px;
            height: 60%;
            right: -12px;
            bottom: 0;
          }

          &::after {
            width: calc(60% + 12px);
            height: 12px;
            right: -12px;
            bottom: -12px;
          }

          .work-link {
            height: 100%;
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: end;
            padding-bottom: 10px;

          }
        }
      }
    }

    // @media screen and (max-width: 432px) {
    //   height: 667px;
    // }
  }

  .slide-3 {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: #FFF9F3;
    font-weight: 400;
    font-style: normal;
    position: relative;
    padding: 0 30px;
    // transition: all 0.3 ease-in;

    // .close-video-button {
    //   position: absolute;
    //   top: -50px;
    //   right: -50px;
    //   z-index: 310000;
    //   width: 30px !important;
    //   height: 30px !important;
    //   cursor: pointer;
    // }


    .showreel-container {
      position: relative;
      height: 100vh;

      // left: 50%;
      // transform: translateX(-50%);
      .play-button {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        cursor: pointer;
        z-index: 30001;
        opacity: 0.9;
        width: 60px;

        @media screen and (max-width: 768px) {
          display: none;
        }
      }




      &.expanded {
        // position: fixed;
        // top: 50%;
        // transform: unset!important;
        // left: 50%;
        // transform: translate(-50%, -50%);
        // z-index: 100;
        // width: 90vw;
        // height: 80vh;
        // max-width: 1200px;
      }

      @media screen and (max-width: 768px) {
        bottom: -100px;
        height: 200px;
        width: 360px;
      }

      video {
        object-fit: cover;
        width: 100%;
        height: 100%;
        padding: 0;
      }

      &::before,
      &::after,
      .top-right::before,
      .top-right::after {
        content: "";
        position: absolute;
        background-color: #00FF00;
      }

      &::before {
        width: 16px;
        height: 50%;
        left: -16px;
        bottom: 0;
      }

      &::after {
        width: calc(50% + 16px);
        height: 16px;
        left: -16px;
        bottom: -16px;
      }

      .top-right::before {
        width: 16px;
        height: 50%;
        right: -16px;
        top: 0;
      }

      .top-right::after {
        width: calc(50% + 16px);
        height: 16px;
        right: -16px;
        top: -16px;
      }
    }

    &__upstart-container {
      position: relative;
      width: 100%;
      max-width: 640px;
      aspect-ratio: 50 / 32.38;
      margin: 0;

      h1 {
        font-family: $font-stack-bison;
        position: absolute;
        left: 20px;
        top: 30px;
        font-size: 2em;

        @media screen and (max-width: 768px) {
          font-size: 1.5em;
          left: 0px;
          top: 30px;
        }

        @media screen and (max-width: 432px) {
          font-size: 1.2em;
          left: 10px;
          top: 20px;
        }
      }
    }

    .upstart-text,
    .upstart-thinking-text,
    .upstart-thinking-outline-1,
    .upstart-thinking-outline-2 {
      position: absolute;
      bottom: unset !important;
      width: 100%;
    }

    .upstart-thinking-text {
      position: absolute;
      z-index: 10;
      left: 0;
    }

    .thinking-text {
      position: absolute;
      left: 0;
      z-index: 10;
      width: 100%;
    }

    &__word {
      display: block;
      color: #000;
      font-weight: 800;
      font-size: 3.4em;
      text-align: center;

      span {
        font-weight: normal;
        font-style: italic;
        font-weight: 200;
      }

      &:hover {
        cursor: pointer;
      }

      @media screen and (max-width: 1024px) {
        font-size: 3.4em;
      }

      @media screen and (max-width: 768px) {
        font-size: 3em;
      }

      @media screen and (max-width: 432px) {
        font-size: 1.8em;
      }

    }

    &__definition {
      display: block;
      max-width: 650px;
      aspect-ratio: 660 / 108;

      p {
        font-size: 1.15em;
        color: #000;
        font-weight: 300;
        text-align: center;
      }

    }

    @media screen and (max-width: 432px) {
      padding: 10% 30px;
      justify-content: start;
      height: 667px;

    }
  }

  .slide-4 {
    width: 100vw;
    height: 100vh;
    display: flex;
    z-index: 2;
    flex-wrap: nowrap;
    position: relative;
    overflow: hidden;

    .panel {
      position: relative;
      box-sizing: border-box;
      width: 100vw;
      height: 100vh;
      padding: 0;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      overflow: hidden;
      transition: width 0.8s cubic-bezier(0.15, 1, 0.5, 1);
      will-change: width;

      &__container {
        position: relative;
        width: 1024px;
        height: 100%;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        flex-direction: column;
        flex-shrink: 0;
        overflow-y: auto;

        &::before,
        &::after {
          content: '';
          flex: 1;
        }

        @media screen and (max-width: 1024px) {
          width: 100vw;
        }
      }

      @media screen and (max-width: 1024px) {
        height: 100vh;
        display: flex;
        padding: 0;
      }
    }

    .panel-brands {
      background-color: transparent;

      &__text-container {
        width: 100%;
        position: relative;
        opacity: 1;

        h2 {
          margin: 0 10px 0 0;
          color: #ffffff;
          font-size: 1.875em;
          font-weight: 300;
          text-align: center;
        }
      }

      &__brand-uppercase {
        width: 70%;
        color: #000;
        z-index: 1;
        padding: 0;
        margin: 0 auto;
        position: relative;

        h4 {
          left: -50px;
          padding: 20px 0;
          font-size: 2em;
          color: #FFFFFF;
          text-transform: uppercase;

          @media screen and (max-width: 1024px) {
            top: -50px;
            left: 50%;
            transform: translateX(-50%);
          }
        }

        img {
          width: 95vw;
          margin: 0 auto;
        }

        @media screen and (max-width: 1024px) {
          width: 100vw;
        }
      }

      &__brand-title {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 50%;
        z-index: 3;

        @media screen and (max-width: 1024px) {
          width: 332px;
        }
      }

      &__brand-thumbs {
        display: flex;
        flex-direction: row;
        justify-content: center;
        width: 100%;
        z-index: 2;
        gap: 20px;
        margin-top: 50px;

        .parallax-container {
          overflow: hidden;
          aspect-ratio: 1 / 1 !important;
          min-width: calc(70% / 4);
          max-width: calc(80% / 4);


          @media screen and (max-width: 1024px) {
            max-width: 100%;
            height: 150px;
          }

          img {
            min-width: 100%;
            max-width: 100%;

          }
        }

        img,
        video {
          min-width: calc(70% / 4);
          max-width: calc(80% / 4);

          @media screen and (max-width: 1024px) {
            max-width: 100%;
            height: 150px;
          }
        }

        @media screen and (max-width: 1024px) {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          width: 310px;
          gap: 10px;
          margin: 2em auto 0;
          aspect-ratio: 1/1;
          align-content: center;
          justify-items: center;

          img {
            width: 100% !important;
            max-width: 100%;
            height: 150px;
          }
        }
      }

    }

    .panel-shopper {
      background-color: #E20034;

      &__text-container {
        width: 100%;
        position: relative;

        h2 {
          margin: 0 10px 0 0;
          color: #ffffff;
          font-size: 1.875em;
          font-weight: 300;
          text-align: center;
        }
      }

      &__shopper-uppercase {
        width: 65%;
        color: #000;
        z-index: 1;
        padding: 0;
        margin: 0 auto;
        position: relative;

        h4 {
          position: absolute;
          top: -40px;
          left: -50px;
          font-size: 2em;
          color: #ffffff;
          text-transform: uppercase;

          @media screen and (max-width: 1024px) {
            top: -50px;
            left: 50%;
            transform: translateX(-50%);
          }
        }

        img {
          width: 95vw;
          margin: 0 auto;
        }

        @media screen and (max-width: 1024px) {
          width: 100vw;
        }
      }

      &__shopper-title {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 50%;
        z-index: 3;

        @media screen and (max-width: 1024px) {
          width: 332px;
        }
      }

      &__shopper-thumbs {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: end;
        width: 100%;
        z-index: 2;
        gap: 20px;
        margin-top: 50px;

        .parallax-container {
          overflow: hidden;
          aspect-ratio: 1 / 1 !important;
          min-width: calc(70% / 4);
          max-width: calc(80% / 4);

          @media screen and (max-width: 1024px) {
            max-width: 100%;
            height: 150px;
          }

          img {
            min-width: 100%;
            max-width: 100%;
          }

          @media screen and (max-width: 1024px) {
            max-width: 100%;
            height: 150px;
          }

        }

        video {
          object-fit: cover;
          height: auto !important;

          &:nth-child(2) {
            width: calc(80% / 4);
            aspect-ratio: 1 / 1;

            @media screen and (max-width: 1024px) {
              width: 100%;
              height: auto !important;
              aspect-ratio: auto;
            }
          }

          &:nth-child(1),
          &:nth-child(3) {
            width: calc(80% / 4 * 0.7);
            aspect-ratio: 1 / 1;

            @media screen and (max-width: 1024px) {
              width: 100%;
              height: 150px !important;
              aspect-ratio: auto;
              display: none;
            }
          }
        }

        @media screen and (max-width: 1024px) {
          display: grid;
          grid-template-columns: repeat(1, 1fr);
          width: 310px;
          gap: 10px;
          margin: 2em auto 0;
          aspect-ratio: 1/1;
          align-content: center;
          justify-items: center;

          img {
            width: 100% !important;
            max-width: 100%;
          }
        }
      }
    }

    .panel-social {
      background-color: #000;
      flex-direction: column;
      overflow: hidden;

      &__text-container {
        width: 100%;
        position: relative;

        h2 {
          margin: 0 10px 0 0;
          color: #ffffff;
          font-size: 1.875em;
          font-weight: 300;
          text-align: center;
        }
      }

      &__social-uppercase {
        width: 85%;
        color: #000;
        z-index: 1;
        padding: 0;
        margin: 0 auto;
        position: relative;

        h4 {
          position: absolute;
          top: -50px;
          left: -50px;
          font-size: 2em;
          color: #FFFFFF;
          text-transform: uppercase;

          @media screen and (max-width: 1024px) {
            top: -50px;
            left: 50%;
            transform: translateX(-50%);
          }
        }

        img {
          width: 95vw;
          margin: 0 auto;
        }

        @media screen and (max-width: 1024px) {
          width: 100vw;
        }
      }

      &__social-title {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 50%;
        z-index: 3;

        @media screen and (max-width: 1024px) {
          width: 332px;
        }
      }

      // &__social-thumb-title {
      //   position: absolute;
      //   left: 50%;
      //   top: 50%;
      //   transform: translate(-50%, -50%);
      //   z-index: 10;
      //   width: 50%;

      //   @media screen and (max-width: 1024px) {
      //     width: 322px;
      //     top: 30%;
      //   }
      // }

      &__social-thumbs {
        display: flex;
        flex-direction: row;
        justify-content: center;
        width: 100%;
        z-index: 2;
        bottom: 0;
        gap: 20px;
        margin-top: 50px;

        .parallax-container,
        video {
          overflow: hidden;
          min-width: calc(70% / 4);
          max-width: calc(80% / 4);

          @media screen and (max-width: 1024px) {
            max-width: 100%;
            height: 150px;
          }
        }

        // :nth-child(2),
        // :nth-child(4) {
        //   z-index: 1;
        // }

        // :nth-child(3) {
        //   z-index: 1;
        // }

        // .social-thumb-title {
        //   position: absolute;
        //   bottom: 0;
        //   left: 50%;
        //   transform: translateX(-50%);
        //   display: flex;

        //   @media screen and (max-width: 1024px) {
        //     width: 115%;
        //     top: -40px;
        //   }

        //   img {
        //     max-width: 100% !important;
        //   }

        //   .cult-title {
        //     margin-bottom: 20%;
        //     margin-right: 5px;
        //   }

        //   .ure-title {
        //     margin-top: 20%;
        //     margin-left: 5px;
        //   }
        // }

        @media screen and (max-width: 1024px) {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          width: 310px;
          gap: 10px;
          margin: 2em auto 0;
          aspect-ratio: 1/1;
          align-content: start;
          justify-items: center;

          img,
          video {
            width: 100% !important;
            max-width: 100%;
            z-index: 1 !important;
          }
        }

        .social-thumb-1,
        .social-thumb-2,
        .social-thumb-3,
        .social-thumb-4 {
          @media screen and (max-width: 1024px) {
            bottom: 0%;
          }
        }
      }
    }


    .panel-comms {
      background-color: #E20034;
      flex-direction: column;
      overflow: hidden;

      &__white-overlay {
        position: absolute;
        inset: 0;
        background-color: #FFF9F3;
        opacity: 0;
        z-index: 20;
        pointer-events: none;
      }

      &__text-container {
        width: 100%;
        position: relative;

        h2 {
          margin: 0 10px 0 0;
          color: #ffffff;
          font-size: 1.875em;
          font-weight: 300;
          text-align: center;
        }
      }

      &__comms-uppercase {
        width: 85%;
        color: #000;
        z-index: 1;
        padding: 0;
        margin: 0 auto;
        position: relative;

        h4 {
          position: absolute;
          top: -50px;
          left: -50px;
          font-size: 2em;
          color: #FFFFFF;
          text-transform: uppercase;

          @media screen and (max-width: 1024px) {
            top: -50px;
            left: 50%;
            transform: translateX(-50%);
          }
        }

        img {
          width: 95vw;
          margin: 0 auto;
        }

        @media screen and (max-width: 1024px) {
          width: 100vw;
        }
      }

      &__comms-title {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        z-index: 10;
        width: 50%;

      }

      &__comms-thumbs {
        display: flex;
        flex-direction: row;
        justify-content: center;
        width: 100%;
        z-index: 2;
        bottom: 0;
        gap: 20px;
        margin-top: 50px;

        :nth-child(1) {
          z-index: 8;
        }

        :nth-child(3) {
          z-index: 8;
        }

        .parallax-container,
        video {
          overflow: hidden;
          min-width: calc(70% / 4);
          max-width: calc(80% / 4);

          @media screen and (max-width: 1024px) {
            max-width: 100%;
            height: 150px;
          }
        }

        @media screen and (max-width: 1024px) {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          width: 310px;
          gap: 10px;
          margin: 2em auto 0;
          aspect-ratio: 1/1;
          align-content: start;
          justify-items: center;

          img,
          video {
            width: 100% !important;
            max-width: 100%;
            z-index: 1 !important;
          }
        }
      }
    }

  }

  .slide-4-mobile {
    width: 100%;
    display: block;
    position: relative;
    box-sizing: border-box;
    width: 100vw;
    height: 667px;
    padding: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    background-color: unset;

    .main-home__slide-static-header h2 {
      margin-top: 30px;
    }

    &.panel-brands {
      background-image: url('../assets/images/brands/brands_script.png');
      background-repeat: no-repeat;
      background-position: 50% 100%;

      .slide-4-mobile__container {
        position: relative;
        max-width: 1025px;
        height: 100vh;
        max-height: 600px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: end;
        flex-direction: column;
        padding: 0 0 40px;

        .panel-brands {

          &__text-container {
            width: 100vw;
            // height: -webkit-fill-available;
            position: relative;
            z-index: 1;
          }

          &__brand-uppercase {
            width: 100%;
            color: #000;
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%) !important;
            z-index: 1;
            padding: 0;

            img {
              height: 106px;
              margin: 0 auto;
            }
          }

          &__brand-title {
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            width: 240px;
            z-index: 3;
          }

          &__brand-thumbs {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            width: 310px;
            gap: 0;
            margin: 0 auto;
            aspect-ratio: 1/1;
            align-content: center;
            justify-items: center;

            img,
            video {
              width: 100% !important;
              max-width: 100%;
            }
          }
        }
      }
    }

    &.panel-passion {
      background-image: url('../assets/images/passion/passion_script.png');
      background-repeat: no-repeat;
      background-position: 50% 100%;

      .slide-4-mobile__container {
        position: relative;
        max-width: 1025px;
        height: 100vh;
        max-height: 600px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: end;
        flex-direction: column;
        padding: 0;
        z-index: 5;

        .panel-passion {
          // background-color: #E20034;

          &__text-container {
            width: 100%;
            // height: -webkit-fill-available;
            position: relative;

            h2 {
              margin: 0 10px 0 0;
              color: #ffffff;
              font-size: 1.875em;
              font-weight: 300;
              text-align: center;
            }
          }

          &__passion-uppercase {
            width: 100%;
            color: #000;
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%) !important;
            z-index: 1;
            padding: 0;

            img {
              height: 106px;
              margin: 0 auto;
            }
          }

          &__passion-title-mobile {
            position: absolute;
            left: 50%;
            top: calc(50% + 5px);
            transform: translate(-50%, -50%);
            width: 280px;
            z-index: 3;

            svg {
              opacity: 1 !important;
              visibility: visible !important;
            }
          }

          &__passion-thumbs {
            height: calc(100% - 200px);
            width: 310px;
            margin: 0 auto;
            aspect-ratio: 1/1;
            align-content: center;
            justify-items: center;

            img,
            video {
              width: 100% !important;
              max-width: 100%;
            }
          }
        }
      }
    }

    &.panel-social {
      // background-color: #E20034;
      flex-direction: column;
      overflow: hidden;

      .slide-4-mobile__container {
        position: relative;
        max-width: 1025px;
        height: 100vh;
        max-height: 600px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: end;
        flex-direction: column;
        padding: 0;
        background-color: #E20034;

        // .panel-social {
        //   &__social-thumb-title {
        //     position: absolute;
        //     left: 50%;
        //     top: 30%;
        //     transform: translate(-50%, -50%);
        //     z-index: 10;
        //     width: 322px;
        //   }

        //   &__social-thumbs {
        //     display: flex;
        //     flex-direction: row;
        //     justify-content: center;
        //     width: 100%;
        //     z-index: 2;
        //     bottom: 0;
        //     gap: 20px;

        //     img {
        //       min-width: calc(70% / 4);
        //       max-width: calc(80% / 4);
        //     }

        //     :nth-child(2),
        //     :nth-child(4) {
        //       z-index: 1;
        //     }

        //     :nth-child(3) {
        //       z-index: -1;
        //     }

        //     .social-thumb-title {
        //       position: absolute;
        //       bottom: 0;
        //       left: 50%;
        //       transform: translateX(-50%);
        //       display: flex;
        //       width: 115%;
        //       top: -40px;

        //       img {
        //         max-width: 100% !important;
        //       }

        //       .cult-title-mobile {
        //         margin-bottom: 20%;
        //         margin-right: 5px;
        //       }

        //       .ure-title-mobile {
        //         margin-top: 20%;
        //         margin-left: 5px;
        //       }
        //     }

        //     @media screen and (max-width: 1024px) {
        //       display: grid;
        //       grid-template-columns: repeat(2, 1fr);
        //       // grid-template-rows: repeat(2, 1fr);
        //       width: 310px;
        //       gap: 0;
        //       margin: 0 auto;
        //       aspect-ratio: 1/1;
        //       align-content: end;
        //       justify-items: center;
        //       height: calc(100% - 20px);

        //       img,
        //       video {
        //         width: 100% !important;
        //         max-width: 100%;
        //         z-index: 1 !important;
        //       }


        //     }


        //     .social-thumb-1,
        //     .social-thumb-2,
        //     .social-thumb-3,
        //     .social-thumb-4 {
        //       bottom: 0%;
        //     }
        //   }
        // }

        .panel-social {

          &__text-container {
            width: 100vw;
            // height: -webkit-fill-available;
            position: relative;
          }

          &__social-thumb-uppercase {
            width: 70%;
            color: #000;
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%) !important;
            z-index: 1;
            padding: 0;

            img {
              height: 106px;
              margin: 0 auto;
            }
          }

          &__social-thumb-title-mobile {
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            width: 280px;
            z-index: 3;
          }

          &__social-thumbs {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            height: calc(100% - 200px);
            width: 310px;
            gap: 0;
            margin: 0 auto;
            aspect-ratio: 1/1;
            align-content: center;
            justify-items: center;

            img,
            video {
              width: 100% !important;
              max-width: 100%;
            }
          }
        }

      }

    }

    &.panel-attitude {
      // justify-content: start;

      .slide-4-mobile__container {
        position: relative;
        max-width: 1025px;
        height: 100vh;
        max-height: 600px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: end;
        flex-direction: column;
        padding: 0;
        background-color: #E20034;

        .panel-attitude {
          &__text-container {
            width: 100vw;
            height: 100vh;
            position: relative;
          }

          &__attitude-uppercase {
            width: 100%;
            color: #000;
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            z-index: 6;
            padding: 0;

            img {
              height: 106px;
              margin: 0 auto;
            }
          }

          &__attitude-title {
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            z-index: 10;
            width: 280px;
          }

          &__attitude-thumbs {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            height: calc(100% - 200px);
            width: 310px;
            gap: 0;
            margin: 0 auto;
            aspect-ratio: 1/1;
            align-content: center;
            justify-items: center;

            :nth-child(1) {
              z-index: 8;
            }

            :nth-child(3) {
              z-index: 8;
            }

            img,
            video {
              width: 100% !important;
              max-width: 100%;
            }
          }

        }

      }

    }
  }

  .we-upstart__container {
    background-color: #E20034;
    position: relative;

    &__title {
      z-index: 0;
      width: 100%;
      height: 100px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      overflow: hidden;


      h2 {
        font-family: $font-stack-bison;
        font-size: 3em;
        line-height: 1;
        font-weight: 300;
        text-align: center;
        color: #ffffff;
        margin-top: 6px;

        @media screen and (min-width: 1025px) {
          display: none;
        }
      }

      &.hidden {
        opacity: 0;
      }
    }

  }


  @media screen and (max-width: 1024px) {

    //.slide-4-desktop,
    .pin-spacer {
      display: none !important;
    }
  }

  @media screen and (min-width: 1025px) {

    .slide-4-mobile {
      display: none;
    }

    .pin-spacer {
      display: flex;
    }
  }

  .slide-6 {
    flex-direction: column;
    justify-content: center;
    background-color: #FFF9F3;
    padding: 10em 0 0;
    min-height: 708px;

    @media screen and (max-width: 1024px) {
      padding: 0;
    }

    h1 {
      font-size: 3em;
      line-height: 1;
      text-align: center;
      padding-bottom: 30px;

      @media screen and (max-width: 1024px) {
        font-size: 2.4em;
      }

    }

    &__container {
      &__title {
        @media screen and (max-width: 1024px) {
          position: relative;
          transform: rotate(0);
          transform-origin: unset;
          left: unset;
          text-align: center;
          bottom: 0%;
        }

        .heading-script {
          color: #E20034;
          top: -34px;
        }


        // .clients_script {
        //   position: relative;
        //   top: 0;
        //   left: 0;
        //   z-index: 1;

        //   img {
        //     transform: rotate(90deg);
        //     width: 100px !important;
        //   }

        //   @media screen and (max-width: 1024px) {
        //     display: none;
        //   }
        // }

        .break-after::after {
          content: unset !important;
          white-space: unset !important;
        }

        @media screen and (max-width: 1024px) {
          .break-after::after {
            content: "\a" !important;
            white-space: pre !important;
            ;
          }
        }

      }

      &__logos {
        display: flex;
        flex-direction: column;
        align-items: center;

        &__row-1,
        &__row-2,
        &__row-3,
        &__row-4 {
          display: flex;
          flex-direction: row;
          align-items: center;
          margin-bottom: 0;
          height: 160px;

          &:last-child {
            margin-bottom: 0;
          }

          @media screen and (max-width: 1024px) {
            height: 90px;
            margin-bottom: 10px;
          }

          .logo-box {
            display: flex;
            justify-content: center;
            width: 220px;
            padding: 4.7rem 0;

            &.london-pride {
              img {
                width: 32%;
              }
            }

            &.lipton {
              img {
                width: 40%;
              }
            }

            &.peroni {
              padding: 3.5rem;

              img {
                width: 100%;
              }
            }

            &.sevenUp {
              padding: 3.5rem;

              img {
                width: 100%;
              }
            }

            &.pepsi {
              img {
                width: 35%;
              }
            }

            &.delonghi {
              padding: 2.5rem;

              img {
                width: 80%;
              }
            }

            &.hilton {
              padding: 2rem;
            }

            &.cleanco {
              img {
                width: 50%;
              }
            }

            &.asahi {
              img {
                width: 45%;
              }
            }

            img {
              width: 60%;
            }

            @media screen and (max-width: 1024px) {
              width: 110px;
              padding: 1rem;

              img {
                width: 75%;
              }


              &.london-pride {
                img {
                  width: 80%;
                }
              }


              &.campari {
                img {
                  width: 100%;
                }
              }

              &.cleanco {
                img {
                  width: 70%;
                }
              }

              &.asahi {
                img {
                  width: 80%;
                }
              }


              &.lipton {
                img {
                  width: 70%;
                }
              }

              &.peroni {
                padding: 0.5rem;

                img {
                  width: 100%;
                }
              }

              &.pepsi {
                img {
                  width: 70%;
                }
              }

              &.delonghi {
                padding: 0.8rem;

                img {
                  width: 100%;
                }
              }

              &.hilton {
                padding: 1.1rem;
              }

              &:nth-child(-n+3) {
                display: flex;
              }
            }
          }
        }

        @media screen and (max-width: 1024px) {
          display: none;
        }

      }

      &__logos_mobile {
        display: none;
        flex-direction: column;
        align-items: center;

        &__row-1,
        &__row-2,
        &__row-3,
        &__row-4 {
          display: flex;
          flex-direction: row;
          align-items: center;
          margin-bottom: 30px !important;
          height: 110px;

          &:last-child {
            margin-bottom: 0;
          }

          @media screen and (max-width: 1024px) {
            height: 90px;
          }

          .logo-box {
            display: flex;
            justify-content: center;
            width: 140px;
            padding: 2rem;

            img {
              width: 80%;
            }

            @media screen and (max-width: 1024px) {
              width: 120px;
              padding: 1rem;

              //display: none;

              &:nth-child(-n+3) {
                display: flex;
              }
            }
          }
        }

        @media screen and (max-width: 1024px) {
          display: flex;
        }
      }

    }

    // @media screen and (max-width: 432px) {
    //   height: 667px;

    // }
  }

  .break-after::after {
    content: "\a";
    white-space: pre;
  }
}

.wrapper {
  z-index: unset;
}

.mobile-indicator {
  position: absolute;
  bottom: 60px;
  left: 50%;
  transform: translateX(-50%);
  pointer-events: none;
  opacity: 1;
  width: 70px;

  img {
    width: 100%;
  }

  @media screen and (min-width: 1025px) {
    display: none;
  }
}

.mobile-indicator[style*="display: none"] {
  opacity: 0;
  /* Fade out */
}

.showreel-container {
  position: relative;
  height: 100vh;
  background: linear-gradient(to bottom, #FFF9F3 50%, #E20034 50%);

  @media screen and (max-width: 768px) {
    background: linear-gradient(to bottom, #FFF9F3 40%, #E20034 40%);
  }

  // left: 50%;
  // transform: translateX(-50%);
  .play-button {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    cursor: pointer;
    z-index: 30001;
    opacity: 0.9;
    width: 60px;

    @media screen and (max-width: 768px) {
      width: 30px;
    }
  }

  .showreel-video-container {
    width: 600px;
    max-width: 90%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    video {
      display: block;
      width: 100%;
      height: auto;
      cursor: pointer;
    }

    @media screen and (max-width: 1024px) {
      width: 80%;
      top: 40%;
      transform: translate(-50%, -40%);
    }

    &::before {
      content: "";
      position: absolute;
      bottom: -11px;
      left: -18px;
      width: 50%;
      height: calc(50% + 11px);
      border-left: 18px solid #00ff00;
      border-bottom: 18px solid #00ff00;
      pointer-events: none;
    }

    &::after {
      content: "";
      position: absolute;
      top: -18px;
      right: -18px;
      width: 50%;
      height: calc(50% + 18px);
      border-right: 18px solid #00ff00;
      border-top: 18px solid #00ff00;
      pointer-events: none;
    }
  }

  &__accolades {
    display: block;
    align-items: center;
    position: absolute;
    bottom: 40px;
    left: 50%;
    transform: translateX(-50%);
    max-width: 160px;
    width: 100%;
    text-align: center;
    color: #fff;
    font-family: $font-stack-bison;
    font-size: 1.5em;
    line-height: 1;
    text-align: left;

    img {
      width: 80%;
    }

    @media screen and (max-width: 1024px) {
      align-items: start;
      font-size: 1.2em;
      padding: 0 20px;
      bottom: 50px;

    }

  }
}

// Expanded showreel (teleported to <body>, so it sits above Lenis and the menu)
.showreel-overlay {
  position: fixed;
  inset: 0;
  z-index: 1000000;

  &__backdrop {
    position: absolute;
    inset: 0;
    background: rgba(0, 0, 0, 0.92);
  }

  &__frame {
    position: fixed;
    background: #000;

    // Same green corner borders as the preview (.showreel-video-container)
    &::before {
      content: "";
      position: absolute;
      bottom: -11px;
      left: -18px;
      width: 50%;
      height: calc(50% + 11px);
      border-left: 18px solid #00ff00;
      border-bottom: 18px solid #00ff00;
      pointer-events: none;
    }

    &::after {
      content: "";
      position: absolute;
      top: -18px;
      right: -18px;
      width: 50%;
      height: calc(50% + 18px);
      border-right: 18px solid #00ff00;
      border-top: 18px solid #00ff00;
      pointer-events: none;
    }

    video {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: cover;
      cursor: pointer;
    }
  }

  // Matches the showreel play button: red disc, 60px, 0.9 opacity.
  // Positioned above the frame by placeShowreelClose().
  &__close {
    position: fixed;
    width: 60px;
    height: 60px;
    padding: 0;
    border: 0;
    background: none;
    opacity: 0.9;
    cursor: pointer;

    svg {
      display: block;
      width: 100%;
      height: 100%;
    }

    &:hover {
      opacity: 1;
    }

    @media screen and (max-width: 768px) {
      width: 40px;
      height: 40px;
    }
  }
}
</style>
